export default "__VITE_ASSET__CE_BurG0__"